document.addEventListener("DOMContentLoaded", function () {
  const sizeChartButton = document.getElementById("sizeChartButton");
  const popupOverlay = document.getElementById("popupOverlay");
  const myPopup = document.getElementById("myPopup");
  const closeBtn = document.querySelector(".popup .close-btn");

  if (sizeChartButton && popupOverlay && myPopup && closeBtn) {
    sizeChartButton.addEventListener("click", openPopup);
    popupOverlay.addEventListener("click", closePopup);
    closeBtn.addEventListener("click", closePopup);
  }

  function openPopup() {
    myPopup.classList.add("active");
    popupOverlay.classList.add("active");
    document.body.classList.add("no-scroll");
    if (document.querySelector('.section-header')) {
      document.querySelector('.section-header').style.zIndex = '0';
    }
    if (document.querySelector('.announcement-bar')) {
      document.querySelector('.announcement-bar').style.zIndex = '0';
    }
  }

  function closePopup() {
    myPopup.classList.remove("active");
    popupOverlay.classList.remove("active");
    document.body.classList.remove("no-scroll");
    if (document.querySelector('.section-header')) {
      document.querySelector('.section-header').style.zIndex = '400';
    }
    if (document.querySelector('.announcement-bar')) {
      document.querySelector('.announcement-bar').style.zIndex = '401';
    }
  }
});
